import {
  BRANCH_CREATE,
  BRANCH_HIDE_MODAL,
  BRANCH_SHOW_MODAL,
  BRANCH_SUCCESS,
  BRANCH_UPDATE,
  HIDE_MODAL,
  SHOW_MODAL,
} from "../constants/BranchConst";
import { BRANCH_FAILED } from "../constants/BranchConst";
import { BRANCH_LOADING } from "../constants/BranchConst";
import { BRANCH_LOAD } from "../constants/BranchConst";

export const success = (data) => {
  return {
    type: BRANCH_SUCCESS,
    data,
  };
};

export const showModal = (data) => {
  return {
    type: BRANCH_SHOW_MODAL,
  };
};

export const hideModal = (data) => {
  return {
    type: BRANCH_HIDE_MODAL,
  };
};

export const failed = () => {
  return {
    type: BRANCH_FAILED,
  };
};

export const loading = () => {
  return {
    type: BRANCH_LOADING,
  };
};

export const loadbranchlist = ({ page, filter }) => {
  return {
    type: BRANCH_LOAD,
    page,
    filter,
  };
};

export const createbranch = (data) => {
  return {
    type: BRANCH_CREATE,
    data,
  };
};
export const updatebranch = (data) => {
  return {
    type: BRANCH_UPDATE,
    data,
  };
};
